import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckboxSize } from '../../../../ui/form-components/checkbox-input/checkbox-input.component';

export type CheckboxState = 'checked' | 'unchecked' | 'indeterminate';

@Component({
  selector: 'app-indeterminate-checkbox',
  templateUrl: './indeterminate-checkbox.component.html',
  styleUrls: ['./indeterminate-checkbox.component.scss']
})
export class IndeterminateCheckboxComponent {
  @Input() controlId: string | null = null;
  @Input() size: CheckboxSize = 'sm';
  @Input() state: CheckboxState = 'unchecked';
  @Input() disabled: boolean = false;

  @Output() checkboxClicked = new EventEmitter<void>();

  public generatedRandomId = `checkbox-${Math.random().toString(36).slice(2)}`;
}
